export default __webpack_public_path__ + "static/media/0xe40d881cf66e1f6d19979a5ff6c830c6af65d278.a9ce05b5.jpg";